import { isArray } from 'util';
import { toJS } from 'mobx';
import getDataPoint from './getDataPoint';
import { translate } from '../Components/Translate';
import { Config } from '../models/config';
import performanceCheck from '../utils/performanceCheck';
import { ShareClass } from '../models/entity';
import { DataLocator } from '../models/configuration/DataLocator';

import GetColumnValueOptions from '../models/utils/GetColumnValueOptions';
import { DataStore } from '../stores';

export function getColumnValue(options: GetColumnValueOptions) {
    const {
        config,
        column,
        shareClass,
        locale,
        fundCurrency,
        defaultNoDataPlaceholder,
        translations,
        dataStore,
    } = options;
    const { property, data } = column;
    if (isArray(toJS(data))) {
        return (data as Array<DataLocator>)
            .map(d => {
                return (
                    translate(
                        translations,
                        getDataPoint({
                            dataStore,
                            shareClass,
                            locale,
                            fundCurrency,
                            defaultNoDataPlaceholder,
                            dataConfig: d as any,
                            hasPerformance: hasPerformance(
                                dataStore,
                                d.performanceCheck,
                                config,
                                shareClass
                            ),
                        })
                    ) + (d.separator || '')
                );
            })
            .join('');
    }

    if (data) {
        return translate(
            translations,
            getDataPoint({
                dataStore,
                shareClass,
                locale,
                fundCurrency,
                defaultNoDataPlaceholder,
                dataConfig: (data as any) as DataLocator,
                hasPerformance: hasPerformance(
                    dataStore,
                    (data as DataLocator).performanceCheck,
                    config,
                    shareClass
                ),
            })
        );
    }

    // Support simple label/property column definition
    if (property) {
        return translate(
            translations,
            getDataPoint({
                dataStore,
                shareClass,
                locale,
                fundCurrency,
                defaultNoDataPlaceholder,
                dataConfig: {
                    property: 'properties_pub',
                    code: property,
                    key: 'value',
                },
                hasPerformance: true,
            })
        );
    }

    return defaultNoDataPlaceholder;
}

function hasPerformance(
    dataStore: DataStore,
    mustCheckPerformance: boolean,
    config: Config,
    shareClass: ShareClass
) {
    if (mustCheckPerformance) {
        return performanceCheck({
            dataStore,
            config,
            shareClass,
        });
    }
    return true;
}



// WEBPACK FOOTER //
// ./src/utils/getColumnValue.ts